module.exports = __webpack_public_path__ + "img/rohde.607a7802.png";